<template>
    <div class="flex-column dropdown-search dropdown-search-third">
        <el-dropdown trigger="click" @command="update">
            <el-input
                :data-bot="getDatabot('name', currentStore, null, third)"
                class="wp-10"
                v-model="defaultValue"
                :placeholder="placeholder"
                @input="searchThird(defaultValue)"
            />
            <el-dropdown-menu slot="dropdown" class="p-2 dropdown-search-third__list" :class="{'hide': !hasQuery && searchDisabled}" placement="bottom" :data-bot="getDatabot('name-popup', currentStore, null, third)">
                <preloader :display="loading" class="loader-small"/>
                <div v-if="!err && !loading" class="prelative dropdown-search-third__items" :class="{'pt-2': hasItems && hasQuery}" >
                    <span v-if="hasItems && hasQuery" class="gray-80 fs-2 lh-20">{{ $l10n.__('Société(s) déjà existante(s) dans le répertoire de société') }}</span>
                    <!-- LIST OF RESULT -->
                    <el-dropdown-item 
                        v-for="(item, index) in result" 
                        :command="item" 
                        :key="index"
                        class="gray-100">
                        <form-fields-companies-list
                            :company="item"
                            :enabled="true"
                            :third="third"
                            allowBadge
                            class="py-2 dropdown-search-third__item"
                            />
                    </el-dropdown-item>
                </div>
                <div :class="{'bt-1': hasItems && hasQuery}">
                    <el-dropdown-item v-if="!searchDisabled" class="not-item ln-20 flex-row my-0" :class="{'mt-2': !searchDisabled && hasItems}">
                        <a href="javascript:;" class="fs-3 px-2 ln-20 mr-2 semibold link" @click="openSearchThirdPopUp()" :data-bot="getDatabot('name-popup', currentStore, null, third)">
                            {{ $l10n.__("Rechercher une nouvelle société") }}
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item class="mb-0 not-item ln-20" v-if="hasQuery">
                        <a href="javascript:;" class="fs-3 px-2 ln-20 mr-2 semibold link" @click="openCreateThirdPopUp(third, 'prospect')" :data-bot="getDatabot('name-popup-add-new', currentStore, null, third)">
                            {{ thirdType }}
                        </a>
                    </el-dropdown-item>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>

import Preloader from "vcomponents/utilities/Preloader.vue";
import FormFieldsCompaniesList from 'vcomponents/thirds/thirdscomponents/FormFieldsCompaniesList.vue';
import DataBotsFormsMixins from "mixins/DataBotsFormsMixins";

import { createNamespacedHelpers } from 'vuex'
const  popupPanelMapActions  = createNamespacedHelpers('popupPanel').mapActions;

export default {
    mixins: [DataBotsFormsMixins],
    props:{
        value: {
            type: String,
            required: true,
            default: ""
        },
        placeholder:{
            type: String,
            required: false,
            default: ""
        },
        currentStore: {
            require: true,
            type: String
        },
        searchDisabled: {
            required: false,
            type: Boolean,
            default: false
        },
        third: {
            required: false,
            type: String,
            default: "company"
        }
    },
    components:{ Preloader, FormFieldsCompaniesList },
    data() {
        return {
            defaultValue: "",
            result: [],
            err: null,
            loading: false,
            hasItems: false
        }
    },
    created(){
        this.defaultValue = !_.isNil(this.value) ? this.value : "";    
    },
    mounted(){
        //resize dropdown (for the sake of design)
        let inputWidth = document.querySelector(".dropdown-search-third").offsetWidth;
        if(!_.isNil(inputWidth) && inputWidth > 0){
            document.querySelector(".dropdown-search-third__list").style.width = inputWidth.toString() + "px";
        }
    },
    computed:{
        hasQuery(){
            return this.defaultValue.length > 0;
        },
        thirdType(){
            let msg = "";
            if(this.third === "company"){
                msg = this.$l10n.__("Ajouter “%s” en tant que nouvelle société", this.defaultValue);
            }else{
                msg = this.$l10n.__("Ajouter “%s” en tant que nouveau particulier", this.defaultValue);
            }
            return msg;
        }
    },
    methods: {
        ...popupPanelMapActions([
            'open'
        ]),
        /**
         * Open a popup throught call of open() from popupPanel.js
         */
        openSearchThirdPopUp(){
            this.open({
                key: "popupThirdForm",
                props: {
                    options:{
                        action: "search",
                        next: "create"
                    },
                    current : this.currentStore,
                    defaultValue: this.defaultValue
                }
            })
        },
        openCreateThirdPopUp(type, subType){
            this.open({
                key: "popupThirdForm",
                props: {
                    options:{
                        action: "create",
                        types: {type : type, subType: subType}
                    },
                    current : this.currentStore,
                    defaultValue: {name : this.defaultValue}
                }
            })
        },
        searchThird:_.debounce(function(){
            this.loading = true;
            this.err = null;
            this.result = [];
            if(_.isEmpty(this.defaultValue)){
                this.defaultValue = "";
            }
            
            this.fetchThird(this.defaultValue).then((res)=>{
                let index = 0;
                this.hasItems = (res.data.length > 0);

                res.data.forEach(company => {
                    this.result[index] = {
                        address: {
                            postal_code : company.invoicing_address?.postal_code || null ,
                            city : company.invoicing_address?.city || null
                        },
                        id: company.object.id,
                        type: company.object.sub_type
                    }
                    if(this.third === "individual"){
                        this.result[index].civility = company.civility || null;
                        this.result[index].forename = company.first_name || null;
                        this.result[index].name = company.last_name || null;
                    }else{
                     this.result[index].name = company.name;
                    }
                    index++;
                })
                this.loading = false;
            }).catch(()=>{
                this.loading = false;
            })
        }, 300),

        fetchThird(value){
            return new Promise((resolve, reject) => {
                if(!_.isNil(value) && value.trim().length > 0){
                    let datas = {
                        q : value,
                        type: [`${this.third}.client`, `${this.third}.prospect`],
                        limit: 25
                    }
                    ApiClient.get("/search", datas).then((res) => {
                        resolve(res.data)
                    }).catch(() => {
                        this.err = this.$l10n.__('Un problème est survenu lors de la recherche. Veuillez réessayer plus tard.');
                        reject();
                    })
                }else{
                    reject();
                }
            })
        },
        update(value) {
            if(!_.isNil(value)){ this.$emit('update', value); }
        },
    }
}
</script>

<style lang="scss">
@import "~@sellsy/styleguide/src/_variables";
.el-dropdown-menu {
    & > div > li {
        margin: 8px 0;
    }
    .el-dropdown-menu__item i{
        place-self: center;
    }
    &.dropdown-search-third__list{
        max-height: 385px;
        min-height: 50px;
    
        //force because some other rules overwrite over a simple py-2
        .py-2{
            padding-top:8px !important;
            padding-bottom:8px !important;
        }
        .dropdown-search-third__items{
            max-height: 250px;
            overflow-y: scroll;
            overflow-x: hidden;
            &::-webkit-scrollbar {
                width: 5px;
            }
            &::-webkit-scrollbar-thumb {
                background: $gray-05;
                border-radius: 10px;
            }
        }
        .el-dropdown-menu__item{
            border-radius: 4px;
        }
        .not-item.el-dropdown-menu__item{
            cursor: initial;
            width: fit-content;
            &:not(.is-disabled){
                &:hover, &:focus{
                background: unset !important;
                }    
            }
        }
        .el-dropdown-menu__item a{
            border-radius: 4px;
        }
    }
}

</style>
